export default __webpack_public_path__ + "static/media/pluto-fatal-error.30f86a7b.png";